import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectInfoSmallComponent } from '../project-info-small/project-info-small.component';
import { PaginationComponent } from '../pagination/pagination.component';
import { InputEditFieldComponent } from '../input-edit-field/input-edit-field.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragulaModule } from 'ng2-dragula';
import { MomentModule } from 'angular2-moment';
import { MainMenuComponent } from '../../main-menu/main-menu.component';
import { RouterModule } from '@angular/router';
import { ObjectStatusComponent } from '../object-status/object-status.component';
import { LaddaModule } from 'angular2-ladda';
import { ProjectStatusComponent } from '../project-status/project-status.component';
import { WidgetStatusComponent } from '../widget-status/widget-status.component';
import { SlugInputComponent } from '../slug-input/slug-input.component';
import { FileUploadModule } from 'ng2-file-upload';
import { AdminOnlyDirective } from '../../auth/admin-only.directive';
import { SizerDirective } from '../sizer.directive';
import { NouisliderModule } from 'ng2-nouislider/src/nouislider';
import { ClipboardModule } from 'ngx-clipboard';
import { UsersSharedModule } from '../../users/shared/users-shared.module';
import { ClarityModule } from '@clr/angular';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragulaModule,
    MomentModule,
    RouterModule,
    FileUploadModule,
    ClarityModule,
    NouisliderModule,
    UsersSharedModule,
    ClipboardModule,
    MomentModule,
    LaddaModule.forRoot({
      style: "slide-left",
      spinnerSize: 26
    }),
  ],
  declarations: [
    ProjectInfoSmallComponent,
    ProjectStatusComponent,
    PaginationComponent,
    InputEditFieldComponent,
    MainMenuComponent,
    ObjectStatusComponent,
    WidgetStatusComponent,
    SlugInputComponent,
    AdminOnlyDirective,
    SizerDirective,
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    ProjectInfoSmallComponent,
    PaginationComponent,
    InputEditFieldComponent,
    MainMenuComponent,
    NouisliderModule,
    LaddaModule,
    DragulaModule,
    ProjectStatusComponent,
    MomentModule,
    FileUploadModule,
    ObjectStatusComponent,
    WidgetStatusComponent,
    SlugInputComponent,
    SizerDirective,
    AdminOnlyDirective,
    RouterModule,
    ClarityModule,
    ClipboardModule,
    MomentModule
  ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared/shared.module.ts